import '../styles/TransferHistoryContinueBand.css';
import React from 'react';

const CONTINUE_CONTROLS = [
  {
    href: '/dashboard',
    label: 'Back to dashboard',
    hint: 'Return to your balance and account overview',
  },
  {
    href: '/transfer',
    label: 'New transfer',
    hint: 'Move funds to another account',
  },
];

function TransferHistoryContinueBand() {
  return (
    <section
      className="thcb-root"
      aria-labelledby="thcb-heading"
    >
      <div className="thcb-panel">
        <div className="thcb-inner">
          <div className="thcb-mark">
            <span className="thcb-mark-rule" aria-hidden="true" />
            <h2 className="thcb-label" id="thcb-heading">
              Continue
            </h2>
          </div>

          <div className="thcb-actions">
            {CONTINUE_CONTROLS.map((control) => (
              <a key={control.href} className="thcb-control" href={control.href}>
                <span className="thcb-control-text">
                  <span className="thcb-control-label">{control.label}</span>
                  <span className="thcb-control-hint">{control.hint}</span>
                </span>
                <span className="thcb-control-route">{control.href}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TransferHistoryContinueBand;